import {
    createContext,
    ReactNode,
    useContext,
} from 'react'

import {FieldValues, useForm, UseFormReturn} from "react-hook-form";

// Define the context type
interface ModalWizzarStepsContextType {
    useFormWizzard:  UseFormReturn<FieldValues,any,FieldValues>
}
const ModalWizardStepsContext = createContext<ModalWizzarStepsContextType | undefined>(undefined)

export const ModalWizzarStepsProvider = (
    {
        children
    }: { children: ReactNode }) => {
    
    const useFormWizzard = useForm()

    const contextValue: ModalWizzarStepsContextType = {
        useFormWizzard
    }

    return (
        <ModalWizardStepsContext.Provider value={contextValue}>
            {children}
        </ModalWizardStepsContext.Provider>
    )
}

// Custom hook to use the table context
export const useModalWizardStepsContext = () => {
    const context = useContext(ModalWizardStepsContext);
    if (context === undefined) {
        throw new Error(
            'useTableContext must be used within a TableContextProvider'
        )
    }
    return context
}
